import { createContext } from 'react';

const memberContext = createContext();

export default memberContext;
